import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { IGenerateJobDescriptionResponse } from '../types';

export const generateJobDescription = async (
  postingId: string,
): Promise<IGenerateJobDescriptionResponse> => {
  const headers = await getAuthHeaders();
  const { data } = await tempMeeApi.post<IGenerateJobDescriptionResponse>(
    `/posting-service/postings/${postingId}/generate-description`,
    undefined,
    { headers },
  );
  return data;
};
